import { render, staticRenderFns } from "./QuestionBankAdmin.vue?vue&type=template&id=d9eb3bca&scoped=true"
import script from "./QuestionBankAdmin.vue?vue&type=script&lang=js"
export * from "./QuestionBankAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9eb3bca",
  null
  
)

export default component.exports